export interface Input {
  content: Marko.Body;
  class?: string;
  style?: Marko.HTMLAttributes["style"];
}

<h2 class=["text2 tracking1 font-semibold", input.class] style=input.style>
  <${input.content}/>
</h2>
